import builder from '../builder';
import NavigationMenuHorizontal from '../../streamline-icons/bold/navigation-menu-horizontal.svg';

export default builder(
  'IconNavigationMenuHorizontalBold',
  NavigationMenuHorizontal,
);
